import { gql } from '@apollo/client';

export const getSupplierAdditionalCostsQuery = gql`
  query GetSupplierAdditionalCosts($sessionId: String!) {
    supplierAdditionalCosts(sessionId: $sessionId) {
      supplierId
      extraHighRoofProductId
      removalOfSolarPanelsProductId
      replaceFuseBoxProductId
      severalRoofSurfacesProductId
      specialPlaceProductId
    }
  }
`;

export default getSupplierAdditionalCostsQuery;
